import React, { useState, useEffect, useContext } from "react";
import EmpresaContext from "../../../../contexts/Empresa";
import api from "../../../../services/api";
import {
  Card,
  CardBody,
  Row,
  Col,
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Produtos from "../Produtos";
import ImoveisModal from "./ImoveisModal";
import CultivosModal from "./CultivosModal";
import BensMovelsModal from "./BensMovelsModal";

export default ({
  oportunidade,
  oportunidadeId,
  readOnly,
  novoClienteId,
  notify,
  onProtudosChange,
  extraProps,
  ...props
}) => {
  const { empresaSelecionada } = useContext(EmpresaContext);

  const [counts, setCounts] = useState({
    produtos: 0,
    imoveis: 0,
    cultivos: 0,
    bensMoveis: 0,
  });

  const [modals, setModals] = useState({
    produtos: false,
    imoveis: false,
    cultivos: false,
    bensMoveis: false,
  });

  const clienteId = novoClienteId ? novoClienteId : oportunidade?.cliente_id;

  useEffect(() => {
    if (clienteId && empresaSelecionada?.id) {
      loadCounts();
    }
  }, [clienteId, empresaSelecionada?.id]);

  async function loadCounts() {
    try {
      const promises = [
        loadProdutosCount(),
        loadImoveisCount(),
        loadCultivosCount(),
        loadBensMovelsCount(),
      ];

      await Promise.all(promises);
    } catch (error) {
      console.error("Erro ao carregar contadores:", error);
    }
  }

  async function loadProdutosCount() {
    if (!oportunidadeId) return;
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidadeId}/produtos`
      );
      setCounts((prev) => ({ ...prev, produtos: response.data.length }));
    } catch (error) {
      console.error("Erro ao carregar produtos:", error);
    }
  }

  function handleProdutosChange(produtosAtualizados) {
    // 1) Se o pai passou um onProtudosChange, repasse os produtos para ele
    if (onProtudosChange) {
      onProtudosChange(produtosAtualizados);
    }

    // 2) Se já existe oportunidade, atualize o contador via API
    if (oportunidadeId) {
      loadProdutosCount();
    } else {
      // Em nova oportunidade, atualiza o contador localmente pelo tamanho do array
      setCounts((prev) => ({
        ...prev,
        produtos: produtosAtualizados?.length || 0,
      }));
    }
  }

  async function loadImoveisCount() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/clientes/${clienteId}/imoveis`
      );
      setCounts((prev) => ({
        ...prev,
        imoveis: response.data.data?.length || 0,
      }));
    } catch (error) {
      console.error("Erro ao carregar imóveis:", error);
    }
  }

  async function loadCultivosCount() {
    try {
      let totalCultivos = 0;
      const imoveisResponse = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/clientes/${clienteId}/imoveis`
      );

      const imoveis = imoveisResponse.data.data || [];

      for (const imovel of imoveis) {
        try {
          const cultivosResponse = await api.get(
            `/common/empresas/${empresaSelecionada?.id}/clientes/${clienteId}/imoveis/${imovel.id}/cultivos`
          );
          totalCultivos += cultivosResponse.data.data?.length || 0;
        } catch (error) {
          console.error(
            `Erro ao carregar cultivos do imóvel ${imovel.id}:`,
            error
          );
        }
      }

      setCounts((prev) => ({ ...prev, cultivos: totalCultivos }));
    } catch (error) {
      console.error("Erro ao carregar cultivos:", error);
    }
  }

  async function loadBensMovelsCount() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/clientes/${clienteId}/bens-moveis`
      );
      setCounts((prev) => ({
        ...prev,
        bensMoveis: response.data.data?.length || 0,
      }));
    } catch (error) {
      console.error("Erro ao carregar bens móveis:", error);
    }
  }

  const toggleModal = (type) => {
    setModals((prev) => ({ ...prev, [type]: !prev[type] }));
  };

  const InfoCard = ({
    icon,
    iconColor,
    title,
    count,
    description,
    onVerMais,
    tooltip,
  }) => (
    <Card
      className="mb-3"
      style={{ backgroundColor: "#f8f9fa", borderRadius: "8px" }}
    >
      <CardBody className="py-3">
        <Row className="align-items-center">
          <Col xs="auto">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: iconColor === "primary" ? "#5e72e4" : "#fff",
                border: iconColor === "primary" ? "none" : "2px solid #5e72e4",
              }}
            >
              <i
                className={icon}
                style={{
                  color: iconColor === "primary" ? "#fff" : "#5e72e4",
                  fontSize: "18px",
                }}
              />
            </div>
          </Col>
          <Col>
            <h6
              className="mb-1"
              style={{ color: "#32325d", fontWeight: "600" }}
            >
              {title}
            </h6>
            <small className="text-muted">{description}</small>
          </Col>
          <Col xs="auto">
            <Button
              color="primary"
              size="sm"
              onClick={onVerMais}
              className="text-secondary"
              style={{ textDecoration: "none", fontWeight: "500" }}
            >
              <i className="fas fa-plus mr-2"></i> Adicionar
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "1rem",
        }}
      >
        <h3>Informações do Cliente</h3>
      </div>
      <InfoCard
        icon="fas fa-shopping-cart"
        iconColor="primary"
        title="Produtos"
        count={counts.produtos}
        description={`${counts.produtos} produto${
          counts.produtos !== 1 ? "s" : ""
        } adicionado${counts.produtos !== 1 ? "s" : ""}`}
        onVerMais={() => toggleModal("produtos")}
      />
      <InfoCard
        icon="fas fa-home"
        iconColor="secondary"
        title="Propriedades / Empreendimentos"
        count={counts.imoveis}
        description={`${counts.imoveis} propriedade${
          counts.imoveis !== 1 ? "s" : ""
        } cadastrada${counts.imoveis !== 1 ? "s" : ""}`}
        onVerMais={() => toggleModal("imoveis")}
        tooltip="Cadastre aqui propriedades, empreendimentos, como fazendas, sítios, lojas etc."
      />
      {empresaSelecionada.perfilNegocio.hash === "agronegocio" && (
        <InfoCard
          icon="fas fa-seedling"
          iconColor="secondary"
          title="Cultivos"
          count={counts.cultivos}
          description={`${counts.cultivos} cultivo${
            counts.cultivos !== 1 ? "s" : ""
          } registrado${counts.cultivos !== 1 ? "s" : ""}`}
          onVerMais={() => toggleModal("cultivos")}
          tooltip="Cadastre aqui o que é produzido pelo cliente."
        />
      )}
      <InfoCard
        icon="fas fa-cogs"
        iconColor="secondary"
        title="Parque Atual (Equipamentos)"
        count={counts.bensMoveis}
        description={`${counts.bensMoveis} equipamento${
          counts.bensMoveis !== 1 ? "s" : ""
        } cadastrado${counts.bensMoveis !== 1 ? "s" : ""}`}
        onVerMais={() => toggleModal("bensMoveis")}
        tooltip="Cadastre aqui implementos agrícolas, equipamentos, frota ou outros itens relacionados."
      />
      <Modal
        size="lg"
        isOpen={modals.produtos}
        toggle={() => toggleModal("produtos")}
      >
        <ModalHeader toggle={() => toggleModal("produtos")}>
          Produtos
        </ModalHeader>
        <ModalBody>
          <Produtos
            readOnly={readOnly}
            notify={notify}
            oportunidade={oportunidade}
            oportunidadeId={oportunidadeId}
            onProtudosChange={handleProdutosChange}
            extraProps={extraProps}
            {...props}
          />
        </ModalBody>
      </Modal>
      <ImoveisModal
        isOpen={modals.imoveis}
        toggle={() => toggleModal("imoveis")}
        clienteId={clienteId}
        empresaId={empresaSelecionada?.id}
        notify={notify}
        onUpdate={loadImoveisCount}
      />
      <CultivosModal
        isOpen={modals.cultivos}
        toggle={() => toggleModal("cultivos")}
        clienteId={clienteId}
        empresaId={empresaSelecionada?.id}
        notify={notify}
        onUpdate={loadCultivosCount}
      />
      <BensMovelsModal
        isOpen={modals.bensMoveis}
        toggle={() => toggleModal("bensMoveis")}
        clienteId={clienteId}
        empresaId={empresaSelecionada?.id}
        notify={notify}
        onUpdate={loadBensMovelsCount}
      />
    </>
  );
};
